import { css } from 'styled-components';
import { breakpoints } from '../../breakpoints';
import { cssfonts } from '../cssfonts';

const common = css`
  font-size: 1.5rem; /* 24px */
  line-height: 1.35; /* 24/32 */

  @media (min-width: ${breakpoints.desktop}) {
    font-size: 1.75rem; /* 28px */
    line-height: 1.3; /* 28/36 */
  }
`;

export const h5 = {
  extrabold: css`
    ${cssfonts.exbold}
    ${common}
  `,
  bold: css`
    ${cssfonts.bold}
    ${common}
  `,
  regular: css`
    ${cssfonts.regular}
    ${common}
  `,
  light: css`
    ${cssfonts.light}
    ${common}
  `,
} as const;

